// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"_button_buttonWrapper__Q5CwN","loadingIcon":"_button_loadingIcon__hAuwQ","rotating":"_button_rotating__-cVTh"};